import * as jsxRuntime from "D:\\JsonToUi_Autocomplete\\json_to_ui\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment